import { Trans } from '@lingui/react/macro';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components/src';
import { useParams } from 'react-router';

import { LearningCenterIcon } from '../../svgs/learningCenterIcon';
import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';

const UPDATES_PATH = `https://help.videa.ai/_hcms/mem/login?redirect_url=https%3A%2F%2Fhelp.videa.ai&hsLang=en`;

export const LearningCenter = () => {
  const { id: patientId } = useParams<{ id: string }>();

  const { trackEvent } = useTrackEvent();

  const handleUpdatesClick = () => {
    trackEvent(mixpanelEvents.productUpdates, {
      patientId,
    });
  };

  return (
    <Tooltip>
      <TooltipTrigger className="vai-bg-transparent vai-border-none vai-px-0 vai-p-0">
        <Button
          size="link"
          variant="icon"
          asChild
          onClick={handleUpdatesClick}
          className="vai-px-0"
        >
          <a
            href={UPDATES_PATH}
            target="_blank"
            rel="noreferrer"
            className="vai-px-0"
          >
            <LearningCenterIcon />
          </a>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <span>
          <Trans>Learning Center</Trans>
        </span>
      </TooltipContent>
    </Tooltip>
  );
};
